import { ProfilingTrackingEvent } from "./../../../../tracking/ProfilingTrackingEvent";
import { PerformanceMonitoringVO } from "./../../../../profiling/vo/PerformanceMonitoringVO";
import { BasicModel } from "./../../../model/BasicModel";
import { SimpleCommand } from "./../../../../commanding/SimpleCommand";
import { PerformanceMonitoringService } from "./../../../../profiling/service/PerformanceMonitoringService";
import { TrackingCache } from "./../../../../tracking/TrackingCache";
import { TrackingEventIds } from "./../../../../tracking/constants/TrackingEventIds";
import { BasicProfilingTrackingCommandVO } from './vo/BasicProfilingTrackingCommandVO';

export class BasicProfilingTrackingCommand extends SimpleCommand {


    public execute(commandVars: any = null): void {
        let vo: BasicProfilingTrackingCommandVO = <BasicProfilingTrackingCommandVO>commandVars;

        const _service = PerformanceMonitoringService.getInstance();

        _service.startMonitoring(vo.measurements);
        _service.onMeasurementFinished.add(() => {
            let profilingTrackingEvent: ProfilingTrackingEvent = (<ProfilingTrackingEvent>TrackingCache.getInstance().getEvent(TrackingEventIds.PROFILING));
            // profilingTrackingEvent.downloadSpeed = BasicModel.basicLoaderData.downloadRateFrameOne;
            let averageMeasurementResults: PerformanceMonitoringVO = _service.performanceMonitoringProxy.averageMeasurementResults;
            _service.trackingCommand.performTracking(averageMeasurementResults, BasicModel.userData.userLevel);
            _service.externalLogCommand.performLog(averageMeasurementResults, 1)
        });
    }

}

